<script>
import router from "@/router";
import { layoutComputed } from "@/state/helpers";
import SideBar from "@/components/side-bar";
import NavBar from "@/components/nav-bar";
import Footer from "../../components/footer.vue";
// import { mapGetters } from "vuex";

/**
 * Vertical layout
 */
export default {
  components: { SideBar, NavBar, Footer },
  data() {
    return {
      type: this.$store
        ? this.$store.state.layout.leftSidebarType
        : null || null,
      width: this.$store ? this.$store.state.layout.layoutWidth : null || null,
      isMenuCondensed: false,
    };
  },
  computed: {
    ...layoutComputed,
  },
  created: () => {
    document.body.removeAttribute("data-layout", "horizontal");
    document.body.removeAttribute("data-topbar", "dark");
    document.body.removeAttribute("data-layout-size", "boxed");
    document.body.classList.remove("auth-body-bg");
  },
  methods: {
    toggleMenu() {
      document.body.classList.toggle("sidebar-enable");
      document.body.setAttribute("mobile-menu", "opened");
      if (window.screen.width >= 992) {
        // eslint-disable-next-line no-unused-vars
        router.afterEach((routeTo, routeFrom) => {
          document.body.classList.remove("sidebar-enable");
          document.body.classList.remove("vertical-collpsed");
        });
        document.body.classList.toggle("vertical-collpsed");
      } else {
        // eslint-disable-next-line no-unused-vars
        router.afterEach((routeTo, routeFrom) => {
          document.body.classList.remove("sidebar-enable");
        });
        document.body.classList.remove("vertical-collpsed");
      }
      this.isMenuCondensed = !this.isMenuCondensed;
    },

    onClickOutSide() {
      document.body.classList.remove("sidebar-enable");
      document.body.classList.remove("vertical-collpsed");
    },
    // include() {
    //   return [document.querySelector(".navbar-header")];
    // },
  },

  mounted() {
    if (this.loader === true) {
      document.getElementById("preloader").style.display = "block";
      document.getElementById("status").style.display = "block";

      setTimeout(function () {
        document.getElementById("preloader").style.display = "none";
        document.getElementById("status").style.display = "none";
      }, 2500);
    } else {
      document.getElementById("preloader").style.display = "none";
      document.getElementById("status").style.display = "none";
    }
    if (document.getElementById("check-footer")) {
      console.log("first found");
    }
  },
};
</script>

<template>
  <div>
    <div id="preloader">
      <div id="status">
        <div class="spinner-chase">
          <div class="chase-dot"></div>
          <div class="chase-dot"></div>
          <div class="chase-dot"></div>
          <div class="chase-dot"></div>
          <div class="chase-dot"></div>
          <div class="chase-dot"></div>
        </div>
      </div>
    </div>
    <div id="layout-wrapper layout-box ">
      <div v-click-outside="onClickOutSide">
        <NavBar v-if="$vuetify.breakpoint.smAndDown" />
        <SideBar
          :is-condensed="isMenuCondensed"
          :type="leftSidebarType"
          :width="layoutWidth"
        />
      </div>

      <!-- ============================================================== -->
      <!-- Start Page Content here -->
      <!-- ============================================================== -->

      <div
        class="main-content menu-backdrop"
        :class="{
          'mt-15': $vuetify.breakpoint.smAndDown,
          'rtl-wrapper': ['ar'].includes(lang),
        }"
      >
        <div class="page-content pt-5">
          <!-- Start Content-->
          <div class="container-fluid"><slot /></div>
        </div>
        <Footer />
      </div>
    </div>
  </div>
</template>
<style lang="scss" scoped>
.menu-backdrop {
  &:after {
    display: none;
  }
}
body.sidebar-enable {
  .menu-backdrop {
    position: relative;
    &:after {
      cursor: pointer;
      display: block;
      content: "";
      position: absolute;
      width: 100%;
      left: 0;
      right: 0;
      top: 0;
      bottom: 0;
      opacity: 0.46;
      background-color: rgb(33, 33, 33);
      z-index: 99;
    }
  }
}
</style>
